/**
 * @file
 * Pluxee HelpCenter autoscroll script.
 */

(function ($) {
    'use strict';
    Drupal.behaviors.pluxeeHelpCenterAutoscroll = {
        attach: function (context, settings) {
            function scrollToIfNotVisible( element ) {
                const elementRect = element.getBoundingClientRect();
                const elementTop = elementRect.top;
                const elementBottom = elementRect.bottom;
                const headerHeight = document.getElementById("header").offsetHeight;
                const offset = window.innerWidth < 1024 ? 8 : 16;
                const headerOffset = headerHeight + offset;
                const isVisible = (elementTop >= headerHeight) && (elementBottom <= window.innerHeight);

                if( !isVisible ) {
                    window.scrollTo({
                        top: elementTop + window.scrollY - headerOffset,
                        behavior: "smooth"
                    });
                }
            }

            $(document).ready(function() {
                const $helpCenterStakeholders = $(".hc-home-stakeholders");
                if ( $helpCenterStakeholders.length ) {
                    const $helpCenterStakeholderLinks = $helpCenterStakeholders.find(".views-row a");
                    $helpCenterStakeholderLinks.each(function(){
                        $(this).on("click", function(event) {
                            sessionStorage.setItem("isRedirect", "true");
                        })
                    });
                    if ( sessionStorage.getItem("isRedirect") ) {
                        sessionStorage.removeItem("isRedirect");
                        scrollToIfNotVisible($helpCenterStakeholders[0]);
                    }
                }
            });
        }
    };
})(jQuery);
